import React from "react";
import { useTranslation } from "react-i18next";

function Row({ label, value, mono }) {
    return (
        <div className="flex items-baseline py-2.5 border-b border-gray-100 last:border-0 gap-4">
            <span className="w-36 text-xs text-gray-500 font-medium shrink-0">{label}</span>
            <span className={`flex-1 text-sm text-gray-900 truncate ${mono ? "font-mono" : ""}`}>
                {value || "—"}
            </span>
        </div>
    );
}

function ActivityTechnicalDetails({ inv, loading }) {
    const { t } = useTranslation();

    // Heavy-only fields tell us the full record is still loading.
    // The light list includes request_id, so check for memory_allocated instead.
    if (loading && inv?.memory_allocated === undefined) {
        return (
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <div className="h-5 w-36 bg-gray-200 rounded animate-pulse mb-3" />
                {[0, 1, 2, 3, 4, 5, 6].map((i) => (
                    <div key={i} className="flex items-center py-2.5 border-b border-gray-100 last:border-0 gap-4">
                        <div className="w-36 h-3 bg-gray-100 rounded animate-pulse shrink-0" />
                        <div className="flex-1 h-3 bg-gray-100 rounded animate-pulse" style={{ maxWidth: `${40 + (i * 13) % 50}%` }} />
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-base font-semibold text-gray-900 mb-2">
                {t("activity.technicalDetails") || "Technical details"}
            </h3>
            <Row
                label={t("activity.when") || "When"}
                value={new Date(inv.created_at).toLocaleString()}
                mono
            />
            <Row
                label={t("activity.requestId") || "Request ID"}
                value={inv.request_id || inv.id}
                mono
            />
            <Row
                label={t("activity.memory") || "Memory"}
                value={`${inv.memory_used || "—"} / ${inv.memory_allocated || "—"} MB`}
                mono
            />
            <Row
                label={t("activity.coldStartLabel") || "Cold start"}
                value={inv.is_cold_start === "true" ? "Yes" : "No"}
            />
            <Row
                label={t("activity.queueWait") || "Queue wait"}
                value={`${inv.queue_wait_time || 0}ms`}
                mono
            />
            <Row
                label={t("activity.sizes") || "Request → Response"}
                value={`${inv.request_size || 0} → ${inv.response_size || 0} B`}
                mono
            />
            <Row label={t("activity.ipLabel") || "IP address"} value={inv.ip_address} mono />
        </div>
    );
}

export default ActivityTechnicalDetails;
